export default __webpack_public_path__ + "static/230-fff60c6c283827a291b8e62692794d77.jpg";